import { MouseEvent } from 'react'
import { Checkbox } from '../checkbox'
import { Text } from '../text'

import {
  generateClassesSelectBox,
  generateClassesSelectBoxCircle,
} from './select-box.constants'

import styles from './select-box.module.css'

import type { SelectBoxProps } from './select-box.type'

const SelectBox = ({
  title,
  children,
  className,
  onChange,
  value,
  hasError = false,
  isMultiple = false,
}: SelectBoxProps) => {
  const onHandleClick = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
  ) => {
    e.stopPropagation()
    onChange(!value)
  }

  const generatedClasses = generateClassesSelectBox(value, hasError, className)
  const generatedClassesCircle = generateClassesSelectBoxCircle(value)

  return (
    <button
      className={generatedClasses}
      type="button"
      onClick={(e) => onHandleClick(e)}
    >
      {!isMultiple ? (
        <span className={generatedClassesCircle}></span>
      ) : (
        <Checkbox
          value={value}
          onChange={() => {}}
          className={styles['check-box']}
        />
      )}

      <Text variant="title-base" className={styles.title}>
        {title}
      </Text>
      {children}
    </button>
  )
}

export default SelectBox
